import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"
// import { FaTelegram } from "react-icons/fa"
import Header from "./header"
import logo from "../images/logo.png"
import { Link } from "gatsby"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          description
        }
      }
      sanityNavigation {
        menu {
          active
          title
          category {
            title
            slug {
              current
            }
          }
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      <div className="container mx-auto mt-5">
        {/* <YellowBar className="mt-3 max-w-screen-xl mx-auto rounded-none xl:rounded shadow flex items-center justify-center font-opensanscond text-xl md:text-3xl transition duration-150 ease-in-out hover:bg-yellow-300">
          <a
            href="https://t.me/FinanzasDeBolsillo"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="telegram"
            className="w-full"
          >
            <div className="flex items-center justify-center">
              <span>
                Приглашаем посетить наш <b>Telegram</b>
              </span>
              <FaTelegram className="ml-5" />
            </div>
          </a>
        </YellowBar> */}
        <main>{children}</main>
      </div>
      <Footer className="max-w-screen-xl mx-auto rounded-none xl:rounded">
        <div className="grid grid-cols-5">
          <div className="col-span-5 md:col-span-2">
            <div className="flex items-center p-5">
              <Link to="/">
                <img
                  src={logo}
                  alt="Персональные финансы"
                  width="40"
                  height="40"
                />
              </Link>
              <p className="font-opensanscond text-xl xl:text-4xl pl-5">
                <Link to="/" className="text-gray-200">
                  {data.site.siteMetadata?.title || `Title`}
                </Link>
              </p>
            </div>
          </div>
          <div className="col-span-5 md:col-span-3 p-5">
            <div className="h-60 md:h-40 grid grid-rows-6 md:grid-rows-4 grid-flow-col items-center gap-4">
              <Link
                to="/"
                activeClassName="activeLinkFooter"
                className="navbarbtn-footer text-gray-100 hover:bg-white hover:bg-opacity-10"
              >
                Новости
              </Link>
              {data.sanityNavigation.menu.map((item, index) => {
                return (
                  item.category.slug && (
                    <Link
                      key={index}
                      activeClassName="activeLink-footer"
                      to={`/${item.category?.slug?.current}`}
                      className="navbarbtn-footer text-gray-100 hover:bg-white hover:bg-opacity-10"
                    >
                      <div>{item.title}</div>
                    </Link>
                  )
                )
              })}
              <Link
                to="/kontakty"
                activeClassName="activeLinkFooter"
                className="navbarbtn-footer text-gray-100 hover:bg-white hover:bg-opacity-10"
              >
                Контакты
              </Link>

              <a
                href="https://t.me/FinanzasDeBolsillo"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="telegram"
                className="navbarbtn-footer text-gray-700 hover:text-gray-800 bg-yellow-300 hover:bg-yellow-400"
              >
                Telegram
              </a>
              <Link
                to="/cookies"
                activeClassName="activeLinkFooter"
                className="navbarbtn-footer text-gray-100 hover:bg-white hover:bg-opacity-10"
              >
                Cookies
              </Link>
            </div>
          </div>
          <div className="col-span-5 flex items-center justify-center p-5">
            <p className="font-opensanscond text-white">
              © {new Date().getFullYear()},{" "}
              <b>{data.site.siteMetadata?.title || `Title`}</b>.{" "}
              {data.site.siteMetadata?.description || `Description`}
            </p>
          </div>
          <div className="col-span-5 flex items-center justify-center pb-5">
            <small className="font-opensanscond text-gray-200">
              Сайт разработан{" "}
              <a
                href="https://staminaweb.ru"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="staminaweb"
                className="hover:underline"
              >
                StaminaWeb
              </a>
            </small>
          </div>
        </div>
      </Footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}
// const YellowBar = styled.div`
//   z-index: -10;
//   height: 70px;
//   background-color: #fde636;
// `
const Footer = styled.footer`
  height: 100%;
  background: rgb(16, 25, 45);
  background: -moz-linear-gradient(
    0deg,
    rgba(16, 25, 45, 1) 0%,
    rgba(35, 81, 160, 1) 100%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(16, 25, 45, 1) 0%,
    rgba(35, 81, 160, 1) 100%
  );
  background: linear-gradient(
    0deg,
    rgba(16, 25, 45, 1) 0%,
    rgba(35, 81, 160, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#10192d",endColorstr="#2351a0",GradientType=1);
`
export default Layout
